import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  OfferBlocklistBrand,
  OfferBlocklistListParams,
  blockOffers,
  listOfferBlocklist,
  unblockOffers,
} from '~/services/PublicOfferFeedService';

export const offerBlocklistQueryKeys = {
  all: ['offerBlocklist'] as const,
  lists: () => [...offerBlocklistQueryKeys.all, 'list'] as const,
  list: (params: OfferBlocklistListParams) => [...offerBlocklistQueryKeys.lists(), params] as const,
};

export function useGetBlockedOffers(params: OfferBlocklistListParams) {
  return useQuery({
    queryKey: offerBlocklistQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await listOfferBlocklist(params, { signal });
    },
    enabled: Boolean(params.brand),
  });
}

export function useBlockOffers(brand: OfferBlocklistBrand) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (offerIds: Array<string>) => {
      return await blockOffers(brand, offerIds);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerBlocklistQueryKeys.all });
    },
  });
}

export function useUnblockOffers(brand: OfferBlocklistBrand) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (offerIds: Array<string>) => {
      return await unblockOffers(brand, offerIds);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerBlocklistQueryKeys.all });
    },
  });
}
